import React from 'react'
import messages from './messages'
import { useIntl } from 'react-intl'
import { MenuButton } from '@arnsbogroup/react-voicearchive'
import { Menu } from '@headlessui/react'
import NiceModal from '@ebay/nice-modal-react'
import ChangeTaskTypeModal from './components/ChangeTaskTypeModal'

const ChangeTaskType = ({ readOnly, task, refetch }) => {
  const { formatMessage } = useIntl()

  const onClick = () => {
    NiceModal.show(ChangeTaskTypeModal, { task })
      .then(refetch)
      .catch((error) => {
        console.error(error)
      })
  }
  const disabled = readOnly || !(['LSA', 'LSP'].includes(task?.type?.shortname))

  return (
    <Menu.Item key='ChangeTaskType' disabled={disabled}>
      {(props) => (
        <MenuButton state="negative"  disabled={disabled} {...props} onClick={onClick}>
          { formatMessage(messages.changeTaskType) }
        </MenuButton>
      )}
    </Menu.Item>
  )
}

export default ChangeTaskType